import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {BehaviorSubject, Observable, combineLatest, fromEvent, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {FirebaseDatasnapshot} from 'src/app/shared/models/firebase-datasnapshot.interface';
import {AuthService} from '../../core/auth/auth.service';
import {FirebaseDataService} from '../../editor-state/firebase-data.service';

const MAX_USERS_SHOWN = 5;

@Injectable()
export class UsersOnlineService {
  constructor(
    private fbDataSvc: FirebaseDataService,
    private authSvc: AuthService
  ) {}

  usersOnlineJsonSubject: BehaviorSubject<any> = new BehaviorSubject([]);
  usersOnlineJson$: Observable<any> = this.usersOnlineJsonSubject.asObservable();

  setupUsers() {
    const userLock$ = fromEvent<unknown>(this.fbDataSvc.diagramLockRef, 'value').pipe(
      map(([dataSnaoshot]: FirebaseDatasnapshot) => dataSnaoshot.val())
    );
    const usersOnline$ = fromEvent<unknown>(this.fbDataSvc.usersRef, 'value').pipe(
      map(([dataSnapshot]: FirebaseDatasnapshot) => dataSnapshot.val()),
      map(json => this.objToArray.bind(this)(json)),
      map(json => _.uniqBy(json, 'id'))
    );

    combineLatest([userLock$, usersOnline$, this.authSvc.user$])
      .pipe(
        switchMap(([userLock, usersOnline, user]) =>
          of(this.transformUsers(userLock, usersOnline, user))
        )
      )
      .subscribe(this.usersOnlineJsonSubject);
  }

  objToArray(obj) {
    const arr = [];

    if (obj && typeof obj === 'object') {
      for (const key of Object.keys(obj)) {
        arr.push(obj[key]);
      }
    }

    return arr;
  }

  transformUsers(userLockId, usersOnline, currUser) {
    const usersWithoutCurrUser = _.clone(usersOnline.filter(user => user.id !== currUser.id));

    if (!userLockId || userLockId === currUser.id) {
      return {
        users: usersWithoutCurrUser.slice(0, MAX_USERS_SHOWN).map(user => {
          user.locked = false;

          return user;
        }),
        oddAmount:
          usersWithoutCurrUser.length > MAX_USERS_SHOWN
            ? usersWithoutCurrUser.length - MAX_USERS_SHOWN
            : 0
      };
    } else {
      return this.setLockedFlag(userLockId, usersWithoutCurrUser);
    }
  }

  setLockedFlag(userLockId, usersOnline) {
    if (usersOnline.length <= MAX_USERS_SHOWN) {
      const userOnline = _.remove(usersOnline, (user: any) => user.id === userLockId)[0];

      if (userOnline) {
        userOnline.locked = true;
        usersOnline.unshift(userOnline);
      }

      return {
        users: usersOnline
      };
    } else {
      const resultArr = usersOnline.slice(0, MAX_USERS_SHOWN);
      const lockedUser = usersOnline.find(user => user.id === userLockId);

      if (!resultArr.includes(lockedUser)) {
        resultArr.pop();
        resultArr.unshift(lockedUser);
      } else {
        const userOnline = _.remove(resultArr, (user: any) => user.id === userLockId)[0];

        if (userOnline) {
          userOnline.locked = true;
          resultArr.unshift(userOnline);
        }
      }

      resultArr.map(user => {
        user.locked = user.id === userLockId;

        return user;
      });

      return {
        users: resultArr,
        oddAmount: usersOnline.length - resultArr.length
      };
    }
  }
}
